import { PROCESSED_TIMESHEET_STATUS_ENUM as STATUS_ENUM } from '../constants';

const ATTACHMENTS_CONFIG = {
    MAX_ITEMS_COUNT: 15,
    MAX_FILE_SIZE_MB: 10,
    FILE_TYPES: {
        'image/jpeg': [],
        'image/png': [],
        'image/heic': [],
        'application/pdf': [],
    },
    FILE_TYPES_LABELS: '.pdf, .heic, .jpeg, .png',
};

const proccessedTimesheetSearchKeysDict = {
    clinicianName: 'Clinician Name',
    recruiterName: 'Recruiter',
    salespersonName: 'Salesperson',
    bookingName: 'Booking Number',
    accountName: 'Billing Account Name',
    contractAccountName: 'Contract Account Name',
    processedTimesheetId: 'Processed Timesheet ID',
};

const searchOptions = Object.entries(proccessedTimesheetSearchKeysDict).map(([key, name]) => ({
    name,
    value: key,
}));

const returnProcessedTimesheetsColumns = (pageType) => {
    switch (pageType) {
        case 'processedTimesheets':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.25,
                    sx: { minWidth: 190 },
                },
                {
                    label: ' ',
                    key: 'isCorrection',
                    size: 0.35,
                    sortable: false,
                    sx: { minWidth: 50 },
                },
                { key: 'processedTimesheetId', label: '# ID', size: 0.5 },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.4,
                    sortable: false,
                    sx: { minWidth: 70 },
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'Billing Account',
                    key: 'accountName',
                    size: 1,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'Contract Account',
                    key: 'contractAccountName',
                    size: 1,
                },
                {
                    label: 'Division',
                    key: 'division',
                    size: 1,
                },
                {
                    label: 'Month Posted',
                    key: 'monthPosted',
                    size: 1,
                },
                {
                    label: 'Approval Date',
                    key: 'approvalDate',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'Account Coordinator',
                    key: 'accountCoordinator',
                    size: 1,
                },
                {
                    label: 'Primary Work Location',
                    key: 'primaryWorkLocation',
                    size: 1,
                },
                {
                    label: 'Salesperson',
                    key: 'salesperson',
                    size: 1,
                },
                {
                    label: 'Recruiter',
                    key: 'recruiter',
                    size: 1,
                },
            ];
        case 'processedTimesheetsBP':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.5,
                },
                {
                    label: ' ',
                    key: 'isCorrection',
                    size: 0.5,
                    sortable: false,
                },
                { key: 'processedTimesheetId', label: '# ID', size: 0.5 },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.5,
                    sortable: false,
                },
                {
                    label: 'Number of work locations',
                    key: 'numberOfWorkLocations',
                    size: 0.5,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'AB5',
                    key: 'ab5',
                    size: 0.5,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'Contract Account',
                    key: 'contractAccountName',
                    size: 1,
                },
                {
                    label: 'Division',
                    key: 'division',
                    size: 1,
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Original Pay',
                    key: 'originalPay',
                    size: 1,
                },
                {
                    label: 'Approval Date',
                    key: 'approvalDate',
                    size: 1,
                },
                {
                    label: 'Month Posted',
                    key: 'monthPosted',
                    size: 1,
                },
            ];
        case 'processedTimesheetsTC':
            return [
                {
                    label: 'Status',
                    key: 'status',
                    size: 1.5,
                },
                {
                    label: ' ',
                    key: 'isCorrection',
                    size: 0.5,
                    sortable: false,
                },
                { key: 'processedTimesheetId', label: '# ID', size: 0.5 },
                {
                    label: 'Processed Timesheet',
                    key: 'processedTimesheet',
                    size: 0.5,
                    sortable: false,
                },
                {
                    label: 'Week Ending Date',
                    key: 'weekEndingDate',
                    size: 1,
                },
                {
                    label: 'Clinician',
                    key: 'clinician',
                    size: 1,
                },
                {
                    label: 'Booking',
                    key: 'booking',
                    size: 1,
                },
                {
                    label: 'Needs Review Reason',
                    key: 'needsReviewReason',
                    size: 2,
                },
                {
                    label: 'Billing Account',
                    key: 'accountName',
                    size: 1,
                },
                {
                    label: 'Special Processing',
                    key: 'specialProcessing',
                    size: 1,
                },
                {
                    label: 'Contract Account',
                    key: 'contractAccountName',
                    size: 1,
                },
                {
                    label: 'Division',
                    key: 'division',
                    size: 1,
                },
                {
                    label: 'Account Coordinator',
                    key: 'accountCoordinator',
                    size: 1,
                },
                {
                    label: 'Primary Work Location',
                    key: 'primaryWorkLocation',
                    size: 1,
                },
                {
                    label: 'Salesperson',
                    key: 'salesperson',
                    size: 1,
                },
                {
                    label: 'Recruiter',
                    key: 'recruiter',
                    size: 1,
                },
            ];
        default:
            return [];
    }
};

const rateTypesEnumApi = {
    perDay: 'PerDay',
    perHour: 'PerHour',
    perWeek: 'PerWeek',
    perBookingDay: 'PerBookingDay',
    perConsult: 'PerConsult',
    perBooking: 'PerBooking',
    each: 'Each',
    notApplicable: 'NotApplicable',
};

const rateTypesEnum = {
    perDay: 'Per Day',
    perHour: 'Per Hour',
    perWeek: 'Per Week',
    perBookingDay: 'Per Booking Day',
    perConsult: 'Per Consult',
    perBooking: 'Per Booking',
    each: 'Each',
    notApplicable: 'Not Applicable',
};

function rateTypesEnumApiToDisplay(value) {
    if (!value) return '-';
    const matchingKey = Object.keys(rateTypesEnumApi).find(
        (key) => rateTypesEnumApi[key] === value
    );
    if (matchingKey && rateTypesEnum[matchingKey]) {
        return rateTypesEnum[matchingKey];
    }
    return value;
}

function getRateTypeKeyFromApiValue(apiValue) {
    if (!apiValue) return null;

    const matchingKey = Object.keys(rateTypesEnumApi).find(
        (key) => rateTypesEnumApi[key] === apiValue
    );

    return matchingKey || null;
}

export const PROCESSED_TIMESHEET_INVOICE_STATUS_ENUM = {
    None: 'None',
    Partial: 'Partial',
    Invoiced: 'Invoiced',
};

export const PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM = {
    Invoiced: 'Invoiced',
    NotInvoiced: 'NotInvoiced',
    NonInvoiceable: 'NonInvoiceable',
};

export const getPtsEntryInvoiceStatusTooltip = ({ invoiceStatus, invoiceNumber } = {}) => {
    if (invoiceStatus === PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM.NonInvoiceable) {
        return 'Non-billable item';
    }

    if (invoiceStatus === PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM.Invoiced) {
        return invoiceNumber
            ? `This item has already been invoiced (Invoice #${invoiceNumber})`
            : 'This item has already been invoiced';
    }

    return null;
};

export const shouldShowPtsEntryInvoiceStatusIcon = (invoiceStatus) =>
    [
        PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM.Invoiced,
        PROCESSED_TIMESHEET_ENTRY_INVOICE_STATUS_ENUM.NonInvoiceable,
    ].includes(invoiceStatus);

export const isPtsEntryPosted = (entry) => entry?.isPosted === true;

export const getPtsEntryPostedTooltip = (entry = {}) =>
    isPtsEntryPosted(entry) ? 'This item has already been posted to Workday' : null;

export const shouldShowPtsEntryPostedIcon = (entry = {}) => isPtsEntryPosted(entry);

const READ_ONLY_STATUSES = [
    STATUS_ENUM.Cancelled,
    STATUS_ENUM.Outdated,
    STATUS_ENUM.Posted,
    STATUS_ENUM.Invoiced,
    STATUS_ENUM.InvoiceReview,
    STATUS_ENUM.Resolved,
    STATUS_ENUM.PayImpactOnly,
    STATUS_ENUM.NoBPImpact,
    STATUS_ENUM.WorkdayError,
];

// Read-only PTS records that are still allowed to change status via the status menu
const STATUSES_ALLOWING_STATUS_CHANGE = [
    STATUS_ENUM.Cancelled,
    STATUS_ENUM.WorkdayError,
    STATUS_ENUM.InvoiceReview,
];

// Read-only PTS records that are still allowed to edit header dates
// (Payroll Date, Month Posted, Approval Date) — these do not affect delta amounts
const READONLY_STATUSES_ALLOWING_HEADER_DATES_CHANGE = [STATUS_ENUM.InvoiceReview];

function isPtsReadOnly(status) {
    return READ_ONLY_STATUSES.includes(status);
}

function isPtsStatusReadOnly(status) {
    return isPtsReadOnly(status) && !STATUSES_ALLOWING_STATUS_CHANGE.includes(status);
}

function canEditAttachments(status) {
    return ![STATUS_ENUM.Outdated, STATUS_ENUM.Resolved].includes(status);
}

function canEditHeaderDates(status) {
    return (
        !isPtsReadOnly(status) || READONLY_STATUSES_ALLOWING_HEADER_DATES_CHANGE.includes(status)
    );
}

export {
    ATTACHMENTS_CONFIG,
    proccessedTimesheetSearchKeysDict,
    searchOptions,
    rateTypesEnumApiToDisplay,
    getRateTypeKeyFromApiValue,
    returnProcessedTimesheetsColumns,
    rateTypesEnumApi,
    rateTypesEnum,
    isPtsReadOnly,
    isPtsStatusReadOnly,
    canEditAttachments,
    canEditHeaderDates,
};
